import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { FcFilm } from "react-icons/fc";
import { useNavigate, Link } from "react-router-dom";

import React, { useState } from "react";

export default function NavBar() {
  // const navigate = useNavigate();
  // let Links = [
  //   { name: "HOME", link: "/" },
  //   // { name: "SERVICE", link: "/" },
  //   // { name: "ABOUT", link: "/" },
  //   // { name: "BLOG'S", link: "/" },
  //   // { name: "CONTACT", link: "/" },
  // ];
  let [open, setOpen] = useState(false);

  return (
    <>
      <div className="shadow-md w-full sticky top-0 left-0">
        <div className="md:flex items-center justify-between bg-white py-4 md:px-10 px-7">
          <div
            className="font-bold text-2xl cursor-pointer flex items-center font-[Poppins] 
      text-gray-800"
          >
            <span className="text-3xl text-indigo-600 mr-1">
              <FcFilm />
            </span>
            Movieman
          </div>

          <div
            onClick={() => setOpen(!open)}
            className="text-3xl absolute right-8 top-6 cursor-pointer md:hidden"
          >
            <AiOutlineMenu name={open ? "close" : "menu"}></AiOutlineMenu>
          </div>

          <ul
            className={`md:flex md:items-center md:pb-0 pb-12 absolute md:static bg-white md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${
              open ? "top-20 " : "top-[-490px]"
            }`}
          >
            <li className="md:ml-8 text-lg md:my-0 my-7">
              <Link
                className="text-gray-800 hover:text-gray-400 duration-500"
                to={"/"}
              >
                Home
              </Link>
            </li>
            <a href="https://movieman-admin.web.app/login">
              {" "}
              <button
                className="bg-indigo-600 text-white font-[Poppins] py-2 px-6 rounded md:ml-8 hover:bg-indigo-400 
    duration-500"
              >
                Login Admin
              </button>
            </a>
          </ul>
        </div>
      </div>
      {/* <header className="bg-tranparent absolute top-0 left-0 w-full flex item-center z-10">
        <div className="container">
          <div className="flex items-center justify-beetwen relative">
            <div className="px-4">
              <a href="" className="font-bold text-lg text-teat-500 block py-6">
                Movieman
              </a>
            </div>
            <div className="flex items-center px-4">
              <button
                id="hamburger"
                name="hamburger"
                type="button"
                className="block absolute right-4 lg:hidden"
              >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </button>
              <nav
                id="nav-menu"
                name="nav-menu"
                className="hidden absolute py-5 bg-white shadow-lg rounded-lg max-w-[250px] w-full right-4 top-full lg:block lg:static lg:bg-transparent lg:max-w-full lg:shadow-none lg:rounded-none"
              >
                <ul className="block">
                  <li className="group">
                    <a
                      href=""
                      className="text-base text-black py-2 mx-8 group-hover:text-primary"
                    >
                      Home
                    </a>
                    <a
                      href=""
                      className="text-base text-black py-2 mx-8 group-hover:text-primary"
                    >
                      Login
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header> */}
    </>
  );
}
